// export const baseUrl = "https://blog-api-production-fc2e.up.railway.app/api";
// export const baseUrl = "http://localhost:5000/api";
export const baseUrl = "https://blog-api-c8j7.onrender.com/api";